export default {
  id: null,
  descricao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/clustermodel.js